import {AlertCircle,Check,Cloud,LoaderCircle} from 'lucide-react';

const labels = {
  saved: 'Alle ændringer gemt',
  dirty: 'Ændringer venter på at blive gemt',
  saving: 'Gemmer ændringer…',
  conflict: 'Nyere version kræver din opmærksomhed',
  error: 'Ændringer er ikke gemt på serveren',
};

export function SaveStatus({status,version}:{status:keyof typeof labels;version?:number}) {
  const Icon = status === 'saved' ? Check : status === 'saving' ? LoaderCircle : status === 'dirty' ? Cloud : AlertCircle;
  return <span className={`save-status save-${status}`} role="status" aria-live="polite" title={version === undefined ? undefined : `Kladdeversion ${version}`}>
    <Icon size={15} aria-hidden="true"/>
    <span>{labels[status]}</span>
  </span>;
}
